<template>
    <!--Edit-->
    <div class="container">
        <div class="page-inner">
            <div class="page-header">
                <h3 class="fw-bold mb-3">Sinistros</h3>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="Sinistro!=''">
                    <div class="card">
                        <div class="card-body">
                            <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#dadcdf">
                                <v-tab value="dados" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;">Pagamento Sinistro</v-tab>
                            </v-tabs>
                            <v-window v-model="tab">
                                <v-window-item value="dados">
                                    <v-form>
                                        <v-container>
                                            <div class="row">
                                                <v-col cols="6" md="6">
                                                    <v-card style="padding: 15px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Dados Sinistro
                                                            </h5>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Sinistro:</strong> {{ this.Sinistro.sntCodigo }} -
                                                                {{ this.Sinistro.tsnNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Garantidora:</strong> {{ this.Sinistro.garNome
                                                                }} - <strong>Imobiliária:</strong> {{ this.Sinistro.imoNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cliente:</strong> {{ this.Sinistro.pedDescricao
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Data Cadastro:</strong> {{
                                                                formattedDate(this.Sinistro.sntDtinclusao) }} <strong>Usuário:</strong> {{ this.Sinistro.cusNome }}
                                                            </p>                                                         
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="6" md="6">
                                                      <v-card v-if="PedidosEndereco != ''" style="padding: 15px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">Endereço
                                                                Contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Endereço:</strong> {{
                                                                    PedidosEndereco[0].pdcEndereco
                                                                }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                    PedidosEndereco[0].pdcComplemento }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cidade/UF:</strong> {{
                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                {{ PedidosEndereco[0].pdcEstado }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Bairro:</strong> {{
                                                                    PedidosEndereco[0].pdcBairro
                                                                }} -  <strong>CEP:</strong> {{
                                                                    PedidosEndereco[0].pdcCep }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Tipo Imóvel:</strong> {{
                                                                    PedidosEndereco[0].pdcTipo
                                                                }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                            </div>
                                            <v-row >
                                                <v-col cols="6" md="6">
                                                    <v-card v-if="PedidosEndereco != ''" style="padding: 15px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Informações Contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Contratação:</strong>  {{ Sinistro.pedId
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Vigência:</strong> {{  formattedDate(PedidoItem.pdiDataVigenciaIni) }} a  {{  formattedDate(PedidoItem.pdiDataVigenciaFim) }}
                                                            </p>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Produto:</strong> {{ PedidoItem.pdiNomeProduto }}
                                                            </p>
                                                              <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                  <strong>Cobertura:</strong> {{  this.DadosPedidoDocumento.multiplicador }} x {{ formatarValor(TotalCobertura)  }} = R$ {{ formatarValor(this.DadosPedidoDocumento.multiplicador*TotalCobertura) }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 20px;">
                                                                <strong>Saldo Cobertura:</strong> {{ formatarValor((this.DadosPedidoDocumento.multiplicador*TotalCobertura) - (TotalSinistrosPagamento + TotalSinistroDebitoAndamento)) }}
                                                            </p>
                                                            <hr />
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Documentos
                                                            </h5>
                                                            <v-row style="padding-top: 5px;padding-bottom: 5px;"> 
                                                                <v-table style="background-color: transparent;">
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Tipo
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Documento
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Visualização
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, index) in ListaSinistroDocumentos"
                                                                            :key="index">
                                                                            <td>{{ item.docNome }}</td>
                                                                            <td>{{ item.sndNomeOriginal }}</td>
                                                                            <td style="text-align: center;">
                                                                                <v-btn v-if="item.sndNomeInterno != ''" icon
                                                                                    @click.prevent="VisualizarDocumento(item.sndNomeInterno)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-file-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                        <tr v-for="(item, index) in ListaSinistroDebitoDocumentos"
                                                                            :key="index">
                                                                            <td>{{ item.docNome }}</td>
                                                                            <td>{{ item.sddNomeOriginal }}</td>
                                                                            <td style="text-align: center;">
                                                                                <v-btn v-if="item.sddNomeInterno != ''" icon
                                                                                    @click.prevent="VisualizarDocumento(item.sddNomeInterno)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-file-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </v-table>
                                                            </v-row>
                                                            <v-row>
                                                            <v-col cols="12" md="12">
                                                                <label>Observações</label>
                                                                {{ Sinistro.sntStatusObs }}
                                                            </v-col>
                                                            </v-row>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="6" md="6">
                                                     <v-row>
                                                        <v-col cols="12" md="12">
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Informações Débito
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 16px;padding-top: 10px;">
                                                                {{ this.Sinistro.sntDescricao }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 20px;padding-top: 10px;">
                                                                <strong>Valor:</strong> 
                                                                {{ formatarValor(parseFloat(this.SinistroDebito.sdbValorDebito)) }}
                                                                <strong style="padding-left: 30px;">Vencimento Original:</strong> 
                                                                {{ formattedDate(this.SinistroDebito.sdbDtDebito) }}
                                                            </p>
                                                        </v-col>
                                                        <v-col cols="12" md="6">
                                                            <label>Data Agendamento</label>
                                                             <v-text-field class="input" v-model="SinistroPagamento.snpDtAgendamento"
                                                                type="date" variant="outlined" :disabled="isSomenteLeitura">
                                                             </v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="6">
                                                            <label>Data Pagamento</label>
                                                             <v-text-field class="input" v-model="SinistroPagamento.snpDtPagamento"
                                                                type="date" variant="outlined" :disabled="isSomenteLeitura">
                                                             </v-text-field>
                                                        </v-col>
                                                         <v-col cols="12" md="9">
                                                            <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                                PDF</label>
                                                            <v-file-input v-model="selectedFilePagamento"
                                                                label="Selecione o comprovante" variant="underlined"
                                                                prepend-icon="mdi-file"
                                                                :disabled="isSomenteLeitura"
                                                                accept="image/*,application/pdf"></v-file-input>
                                                        </v-col>
                                                        <v-col cols="12" md="3">
                                                            <button type="button" class="btn btn-info"
                                                                :disabled="isSomenteLeitura"
                                                                @click.prevent="InserirDocumentoPagamento()"
                                                                style="color:#ffffff;margin-top: 20px;">
                                                                Anexar
                                                            </button>
                                                        </v-col>
                                                         <v-col cols="12" md="12" style="padding-top: 5px;padding-bottom: 5px;"> 
                                                            <v-table>
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left">
                                                                            Tipo
                                                                        </th>
                                                                        <th class="text-left">
                                                                            Documento
                                                                        </th>
                                                                        <th class="text-left">
                                                                            Visualização
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in ListaSinistroPagamentoDocumento"
                                                                        :key="index">
                                                                        <td>{{ item.docNome }}</td>
                                                                        <td>{{ item.spdNomeOriginal }}</td>
                                                                        <td style="text-align: center;">
                                                                            <v-btn v-if="item.spdNomeInterno != ''" icon
                                                                                @click.prevent="VisualizarDocumento(item.spdNomeInterno)"
                                                                                variant="text">
                                                                                <v-icon>mdi-file-eye</v-icon>
                                                                                <v-tooltip activator="parent"
                                                                                    location="top">Visualizar</v-tooltip>
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </v-table>
                                                        </v-col>
                                                         <v-col cols="12" md="12">
                                                            <label>Observações</label>
                                                            <textarea cols="5" rows="5" style="width: 100%;" class="form-control" v-model="SinistroPagamento.snpObservacao" maxlength="255" :disabled="isSomenteLeitura"
                                                                placeholder="Observações">
                                                            </textarea>
                                                        </v-col>
                                                     </v-row>
                                                     <v-row>
                                                        <v-col v-if="!isSomenteLeitura" cols="4" md="4">
                                                            <button type="button" class="btn btn-success" style="color:#ffffff;" @click="PutSituacao()">
                                                                Salvar
                                                            </button>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-window-item>
                            </v-window>
                        </div>
                          <div class="card-action" v-if="tab == 'dados' && !isSomenteLeitura" style="text-align: center;">
                            <button type="button" class="btn btn-danger" style="color:#ffffff;" @click="CancelarSinistro()">
                                Cancelar Sinistro
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import { useRoute } from 'vue-router';

export default {
    name: 'SinistroPagamentoDetalheView',
    components: {
        EasyDataTable,
        moment
    },
    setup() {
        const route = useRoute();
        const id = route.params.id;
        return {
            id,
        };
    },
    data: () => ({
        tab: null,
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0,
            cusid: 0
        },
        searchValue: '',
        MostraGrid: true,
        headers: [],
        Sinistro: {
            sntId: 0,
            sntIdCript: '',
            tsnId: 0,
            sntCodigo: '',
            sntDescricao: '',
            sntDtinclusao: '',
            cusId: null,
            imoId: null,
            garId: null,
            pedId: null,
            sstIdAtual: null,
            sntStatusObs: ''
        },
        SinistroDebito: {
            sdbId: 0,
            sdbIdCript: '',
            sntId: 0,
            cusId: null,
            sdbDtInclusao: '',
            sdbValorDebito: 0,
            sdbDtDebito: ''
        },
        ListSinistrosGeral: [],
        SituacoesSinistro: [],
        //pedidoendereco
        PedidosEndereco: [],
        PedidoItem: [],
        PedidoItemAdicional: [],
        PedidoDocumento: [],
        //documentos
        selectedFile: '',
        selectedFileDebito: '',
        DocSelected: null,
        DocSelectedDebito: null,
        ListaDocumentos: [],
        ListaDebitoDocumentos: [],
        ListaSinistroDocumentos: [],
        ListaSinistroDebitoDocumentos: [],
        TotalSinistrosPagamento: 0,
        TotalSinistroDebitoAndamento: 0,
        TotalCobertura: 0,
        DadosPedidoDocumento: '',
        SinistroPagamento:{
            snpId: 0,
            sntId: 0,
            snpDtinclusao:null,
            snpDtAgendamento: null,
            snpValor: 0,
            snpDtPagamento: null,
            pstIdAtual: null,
            snpObservacao: ''
        },
        selectedFilePagamento:'',
        SinistroPagamentoDocumento: {
            spdId: 0,
            snpId: 0,
            cusId: null,
            spdDtInclusao: null,
            spdNomeOriginal: '',
            spdNomeInterno: '',
            docId: ''
        },
        ListaSinistroPagamentoDocumento: [],
    }),
    computed: {
        isSomenteLeitura() {
            return Number(this.SinistroPagamento?.pstIdAtual || 0) === 30;
        }
    },
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
                return {
                    ...item,
                    proOrdem: parseInt(item.proOrdem),
                };
            });
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/SinistroPagamentoDetalhe/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/SinistroPagamentoDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        VisualizarDocumento(item) {
            if (item) {
                this.openInNewTab(item);
            }
        },
        async InserirDocumentoPagamento(){
            if (this.isSomenteLeitura) return;

            if (this.selectedFilePagamento == '' || this.selectedFilePagamento == null) {
                this.$mensagemAviso("Selecione comprovante a ser enviado.")
            }
            else {

                try {
                    const uploadSuccess = await this.UploadImg(this.selectedFilePagamento[0]);

                    if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
                        this.SinistroPagamentoDocumento.spdNomeOriginal = this.selectedFilePagamento[0].name;
                        this.SinistroPagamentoDocumento.spdNomeInterno = uploadSuccess.data.nameFile;
                        this.SinistroPagamentoDocumento.spdDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss');
                        this.SinistroPagamentoDocumento.cusId = this.User.cusid;
                        this.SinistroPagamentoDocumento.docId = 5;
                        this.SinistroPagamentoDocumento.docNome = 'Comprovante Pagamento';

                        // Adiciona cópia do documento à lista
                        this.ListaSinistroPagamentoDocumento.push({ ...this.SinistroPagamentoDocumento });
                        //console.log('this.ListaSinistroDebitoDocumentos')
                        //console.log(this.ListaSinistroDebitoDocumentos)

                        // Limpa seleções
                        this.selectedFilePagamento = '';
                        this.SinistroPagamentoDocumento = {
                            spdId: 0,
                            snpId: 0,
                            cusId: null,
                            spdDtInclusao: null,
                            spdNomeOriginal: '',
                            spdNomeInterno: '',
                            docId: ''
                        };
                    } else {
                        this.$mensagemErro("Erro inesperado ao processar o arquivo. Tente novamente.");
                    }
                } catch (error) {
                    // Trata erro retornado pelo backend (ex: BadRequest)
                    const mensagem = error.response?.data || "Erro ao enviar o documento.";
                    this.$mensagemErro(mensagem);
                }
            }
        },
        //enderecoPedido
        async SelecionarEnderecoPedido() {
            this.PedidosEndereco = [];
            await axios.get('/Telas/SinistroAprovacaoDetalhe/GetAllByPedIdEndereco/' + this.Sinistro.pedId)
                .then(response => {
                    this.PedidosEndereco = response.data;
                    // console.log('PedidosEndereco')
                    // console.log(this.PedidosEndereco)
                })
                .catch(error => {
                    console.error(error);
                });


        },
        async PutSituacao() {
            if (this.isSomenteLeitura) return;

           
            if ((this.SinistroPagamento.snpDtAgendamento === '' || this.SinistroPagamento.snpDtAgendamento === null) &&
               (this.SinistroPagamento.snpDtPagamento === '' || this.SinistroPagamento.snpDtPagamento === null)
                ) return this.$mensagemAviso("Preencha data agendamento ou data pagamento.");

            if ((this.SinistroPagamento.snpDtPagamento != '' && this.SinistroPagamento.snpDtPagamento != null) &&
             (this.ListaSinistroPagamentoDocumento.length == 0)
            ) return this.$mensagemAviso("Anexe comprovante de pagamento.");
            

            //altera pagamento
            let _status = 0;
            let _statusTexto = '';
            let _textoResumo = '';
            if ((this.SinistroPagamento.snpDtAgendamento != '' && this.SinistroPagamento.snpDtAgendamento != null) &&
               (this.SinistroPagamento.snpDtPagamento == '' || this.SinistroPagamento.snpDtPagamento == null))
               {
                  _status = 20;
                  _statusTexto = 'PAGAMENTO AGENDADO';
                  _textoResumo = 'Agendamento data: ' + this.formattedDate(this.SinistroPagamento.snpDtAgendamento);
               }
               else if ((this.SinistroPagamento.snpDtPagamento != '' && this.SinistroPagamento.snpDtPagamento != null)){
                  _status = 30;
                  _statusTexto = 'PAGAMENTO EFETUADO';
               }
            this.SinistroPagamento.pstIdAtual = _status;
            var result = await axios.put('/Telas/SinistroPagamentoDetalhe/PutSinistroPagamento', this.SinistroPagamento);
            const Id = result?.data;

              const dt = moment().format('YYYY-MM-DDTHH:mm:ss');

                // (opcional) garante a prop reativa no Vue 2
                (this.ListaSinistroPagamentoDocumento || []).forEach(el => { if (el.spdId == null) el.spdId = 0; });

                // salva documentos SEQUENCIALMENTE (um por vez)
                for (const [i, element] of (this.ListaSinistroPagamentoDocumento || []).entries()) {
                const payload = {
                    spdId: 0,
                    snpId: this.SinistroPagamento.snpId,
                    cusId: element.cusId,
                    spdDtInclusao: dt,
                    spdNomeOriginal: element.spdNomeOriginal,
                    spdNomeInterno: element.spdNomeInterno,
                    docId: element.docId
                };

                const resp = await axios.post('/Telas/SinistroPagamentoDetalhe/AddSinistroPagamentoDocumento', payload);

                // pode vir número puro ou objeto { sddId: ... }
                let novoId = resp?.data;
                if (typeof novoId === 'object' && novoId !== null) {
                    novoId = novoId.sddId ?? novoId.id ?? 0;
                }

                if (Number(novoId) > 0) {
                    if (this.$set) this.$set(this.ListaSinistroPagamentoDocumento[i], 'spdId', Number(novoId)); // Vue 2
                    else this.ListaSinistroPagamentoDocumento[i].spdId = Number(novoId);                        // Vue 3
                } else {
                    console.warn('Falha ao salvar pagamento doc:', element, resp?.data);
                }
                }

            if (Id > 0) {
                this.AddHistoricoPagamentoStatus(this.SinistroPagamento.snpId, _status,this.SinistroPagamento.snpObservacao);
                this.EnviaAvisoPagamentoImobiliaria(_statusTexto,this.SinistroPagamento.snpObservacao,_textoResumo);
                 this.$mensagemAvisoSucesso?.('Registro Atualizado.');
                this.$router.push('/listasinistrospagamento');
            }
        },
        //Historico pagamento
         async AddHistoricoPagamentoStatus(item, status, obs) {
            let _hist = {
                sphId: 0,
                snpId: item,
                sphDtInclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
                pstId: status,
                cusId: this.User.cusid,
                sphObservacao: obs
            }
            await axios.post('/Telas/SinistroPagamentoDetalhe/AddSinistroPagamentoHistoricoStatus', _hist);

        },
        async EnviaAvisoPagamentoImobiliaria(_statusTexto, obs, textoResumo) {
           await axios.get(`/Telas/SinistroPagamentoDetalhe/GetByIdMensagemPadrao/22`)
                .then(response => {
                    this.templateEmail = response.data;

                    let _texto = _statusTexto;

                    let _dadosEmail = {
                        nomeDe: this.Sinistro.garNome,
                        nomePara: this.Sinistro.imoNome,
                        assunto: 'Status de Pagamento Sinistro: ' + this.Sinistro.sntCodigo,
                        destinatario: this.Sinistro.imoEmail,
                        emailResposta: this.Sinistro.garEmail,
                        textoEmail: this.templateEmail.mpdTexto.replace('[CodSinistro]', this.Sinistro.sntCodigo)
                            .replace('[NovoStatus]', _texto) 
                            .replace('[TextoResumo]', textoResumo) 
                            .replace('[TextoObs]', obs) 
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                        listAnexos: null
                    }
                    axios.post(`/Telas/SinistroPagamentoDetalhe/Enviamail`, _dadosEmail)
                        .then(response => {
                            console.log(response.data)
                            let _envio = {
                                seeId: 0,
                                sntId: this.Sinistro.sntId,
                                seeDtEnvio: moment().format('YYYY-MM-DDTHH:mm:ss'),
                                seeEmailDestinatario: this.Sinistro.imoEmail,
                                seeTipoEnvio: this.templateEmail.mpdNome
                            }
                            axios.post('/Telas/SinistroPagamentoDetalhe/AddSinistroEnvioEmail', _envio);
                        });
                });
        },
         dadosContrato(value) {
                const raw = value;
                try {
                const obj = typeof raw === 'object' && raw !== null ? raw : JSON.parse(raw);

                // helpers de normalização
                const toNum = v => (v === '' || v == null) ? 0 : Number(String(v).replace(',', '.')) || 0;
                const toNumX = v => {                 // "22x" -> 22
                    const m = String(v || '').match(/\d+/);
                    return m ? Number(m[0]) : 0;
                };

                return {
                    idPedido: obj.idPedido,
                    multiplicador: toNumX(obj.multiplicador),   // 22
                    custoSaida: toNumX(obj.custoSaida),         // 3
                    valorContratado: toNum(obj.valorContratado),// 246
                    valorLocaticio: toNum(obj.valorLocaticio),  // 0
                    valorTaxa: toNum(obj.valorTaxa),            // 0.08
                    setup: toNum(obj.setup)                     // 150
                };
                } catch (e) {
                console.warn('JSON inválido em pftDadosContrato:', e);
                return {};
                }
        },
        async CancelarSinistro(){
         if (this.isSomenteLeitura) return;

         this.$mensagemSimNao('Aviso: O cancelamento do sinistro é irreversível, confirma cancelamento?')
                .then((result) => {
                    if (result.isConfirmed) {
                        this.Sinistro.sstIdAtual = -20;
                      axios.put('/Telas/SinistroPagamentoDetalhe/PutSinistro', this.Sinistro);
                       this.$router.push('/listasinistrospagamento');
                    }
                });
        },
        async Get() {
            var _id = '';
            if (this.id != '') {
                _id = this.id;
            }
          await axios.get(`/Telas/SinistroPagamentoDetalhe/GetDados/` + _id)
            .then(response => {
                const d = response?.data ?? {};

               

                // ───────── Helpers ─────────
                const asArr = v => Array.isArray(v) ? v : [];
                const first = a => (Array.isArray(a) && a.length) ? a[0] : null;
                const toNum = v => {
                    if (v == null || v === '') return 0;
                    if (typeof v === 'number') return v;

                    const texto = String(v).trim();
                    if (texto.includes(',')) return Number(texto.replace(/\./g, '').replace(',', '.')) || 0;

                    return Number(texto) || 0;
                };
                const sumBy = (list, selector) => asArr(list).reduce((acc, item) => acc + (selector(item) || 0), 0);

                // Parse seguro do JSON de pftDadosContrato (string -> objeto)
                const parseDadosContrato = raw => {
                try {
                    const obj = (raw && typeof raw === 'object') ? raw
                            : (typeof raw === 'string' && raw.trim() !== '' ? JSON.parse(raw) : {});
                    // Normalizações básicas (ajuste se quiser manter como string)
                    const toNumX = v => { const m = String(v ?? '').match(/\d+/); return m ? Number(m[0]) : 0; };
                    return {
                    idPedido: obj.idPedido ?? null,
                    multiplicador: toNumX(obj.multiplicador),
                    custoSaida: toNumX(obj.custoSaida),
                    valorContratado: toNum(obj.valorContratado),
                    valorLocaticio: toNum(obj.valorLocaticio),
                    valorTaxa: toNum(obj.valorTaxa),
                    setup: toNum(obj.setup)
                    };
                } catch {
                    return {};
                }
                };

                // ───────── Atribuições seguras ─────────
                this.User.tpeid = d.tpeId ?? null;
                this.User.garid = d.garId ?? null;
                this.User.cusid = d.cusId ?? null;
                this.User.pesid = d.pesId ?? null;

                this.Sinistro = d.sinistro ?? {}; // pode vir null
                if (d.sinistroPagamento!= null){
                  this.SinistroPagamento = d.sinistroPagamento[0];
                  this.SinistroPagamento.snpDtAgendamento =this.SinistroPagamento.snpDtAgendamento != null ? moment(this.SinistroPagamento.snpDtAgendamento).format('YYYY-MM-DD'): null;
                  this.SinistroPagamento.snpDtPagamento =  this.SinistroPagamento.snpDtPagamento != null ? moment(this.SinistroPagamento.snpDtPagamento).format('YYYY-MM-DD'): null;
                }

                this.PedidoItem = first(d.pedidoItem) ?? {};                     // [0] seguro
                this.PedidoItemAdicional = asArr(d.pedidoItemAdicional);         // array ou []
                this.PedidoDocumento = asArr(d.pedidoDocumentos);                // array ou []
                this.ListaSinistroDocumentos = asArr(d.sinistroDocumento);

                // pftDadosContrato do primeiro documento, se existir
                const doc0 = first(this.PedidoDocumento);
                this.DadosPedidoDocumento = doc0 ? parseDadosContrato(doc0.pftDadosContrato) : {};

                // Totais (somando com conversão para número)
                this.TotalCobertura = sumBy(this.PedidoItemAdicional, i => toNum(i.piaValorTotalProduto));

                // Débito (pega o primeiro se existir)
                const debitos = asArr(d.sinistroDebito);
                if (debitos.length > 0) {
                this.SinistroDebito = { ...debitos[0] };
                this.SinistroDebito.sdbValorDebito = sumBy(debitos, i => toNum(i.sdbValorDebito));

                // sdbValorDebito para exibição com vírgula (se vier número, vira string antes)
                if (this.SinistroDebito.sdbValorDebito != null) {
                    this.SinistroDebito.sdbValorDebito = this.SinistroDebito.sdbValorDebito;
                }

                // data só se existir
                if (this.SinistroDebito.sdbDtDebito) {
                    this.SinistroDebito.sdbDtDebito = moment(this.SinistroDebito.sdbDtDebito).format('YYYY-MM-DD');
                }

                this.ListaSinistroDebitoDocumentos = asArr(d.sinistroDebitoDocumento);
                } else {
                this.SinistroDebito = {};
                this.ListaSinistroDebitoDocumentos = [];
                }

                // Chama só no final (se depender dos dados acima)
                if (this.Sinistro != ''){
                 this.SelecionarEnderecoPedido?.();
                }

            })
            .catch(err => {
                console.error('Erro ao buscar dados do sinistro:', err);
                // Defaults seguros em caso de erro
                this.Sinistro = {};
                this.PedidoItem = {};
                this.PedidoItemAdicional = [];
                this.PedidoDocumento = [];
                this.ListaSinistroDocumentos = [];
                this.DadosPedidoDocumento = {};
                this.TotalSinistrosPagamento = 0;
                this.TotalSinistroDebitoAndamento = 0;
                this.TotalCobertura = 0;
                this.SinistroDebito = {};
                this.ListaSinistroDebitoDocumentos = [];
            });

        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}

.fontaprova {
    font-size: 16px;
    font-weight: 600;
}
</style>
